import 'bootstrap/dist/css/bootstrap.css';
import './css/style.css';
import './filters';

import router from './router'
import store from './store'
import modalPlugin from './plugins/modalPlugin';
import FILTERS from '@/filters';

import App from '@/App.vue';
import { createApp } from 'vue';
import loadComponents from './componentsLoader';
import ModalsContainer from './plugins/modalPlugin/modalsContainer.vue';
import { ModalServices } from './services/ModalServices';
import { CommonServices } from './services/CommonServices';


router.afterEach((to, from) => {
});

const app = createApp(App)
    .use(store)
    .use(router)
    .use(modalPlugin);

app.config.globalProperties.$filters = FILTERS;

CommonServices.showSpinnerCb = () => {
    store.state.showSpinner++;
}
CommonServices.hideSpinnerCb = () => {
    store.state.showSpinner--;
    if(store.state.showSpinner < 0){
        store.state.showSpinner = 0;
    }
}
CommonServices.unauthorizedCb = () => {
    if(router.currentRoute.value.path != '/')
        router.push('/?redirect=' + router.currentRoute.value.fullPath);
}
CommonServices.validationErrorsCb = (errors) => {
    ModalServices.validationErrorModal(errors);
}

loadComponents(app);

app.component('opModalContainer', ModalsContainer)

app.mount('#app');

